// client/src/index.js
import React from 'react'; // Import React and Suspense
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './core/App';
import './core/i18n'; // Import i18n configuration *before* App
import reportWebVitals from './reportWebVitals';
import LoadingSpinner from './components/common/LoadingSpinner'; // Import your spinner

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        {/* Wrap the entire App component with Suspense */}
        <React.Suspense fallback={<LoadingSpinner />}>
            <App />
        </React.Suspense>
    </React.StrictMode>
);

reportWebVitals();